'use client';

import type { NextPage } from 'next';
import Image from 'next/image';
import styles from './HeraHeader.module.scss';
import { HeraHeaderProps } from '@/types/header.types';
import Link from 'next/link';
import { useState, useCallback } from 'react';
// import SidebarMenu from './SidebarMenu/SidebarMenu';

const RequestQuoteHeader: NextPage<HeraHeaderProps> = ({
  className = '',
  state = 'Desktop',
}) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const handleBackdropClick = useCallback(
    (e: React.MouseEvent<HTMLDivElement>) => {
      if (e.target === e.currentTarget) {
        setIsSidebarOpen(false);
      }
    },
    []
  );

  return (
    <>
      <div
        className={[styles.heraheader, className].join(' ')}
        data-state={state}
      >
        <Link href="/" className={styles.logoLink}>
          <Image
            className={styles.logoIcon}
            width={66}
            height={66}
            sizes="100vw"
            alt="Logo"
            src="/img/header/logo-mob1.png"
          />
          <Image
            className={styles.logoIcon1}
            loading="lazy"
            width={162}
            height={66}
            sizes="100vw"
            alt="Logo Extended"
            src="/img/header/logo-desc1.png"
          />
        </Link>
      </div>

      <div
        className={`${styles.sidebarWrapper} ${isSidebarOpen ? styles.open : ''}`}
        onClick={handleBackdropClick}
      >
        {/* <div className={styles.sidebarContent}>
          <SidebarMenu onClose={() => setIsSidebarOpen(false)} />
        </div> */}
      </div>
    </>
  );
};

export default RequestQuoteHeader;
